import Image from "next/image";

import { cn } from "@/src/lib/shadcn-utils";

export default function Logo({ size = "small", className }: { size?: "small" | "large"; className?: string }) {
  return (
    <span className={cn("h-6 w-6", size === "large" ? "h-12 w-12" : "", className)}>
      <Image
        className="dark:invert select-none"
        src="/logo-icon.svg"
        alt="Valerie Health Logo"
        width={size === "large" ? 48 : 24}
        height={size === "large" ? 48 : 24}
      />
    </span>
  );
}
